import * as React from 'react';
import { Form, Formik } from 'formik';
import { getStartDateForSchoolYear } from '../../../../../helpers/calendar/calendar';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface ToggleDefinition {
  field: string;
  label: string;
  hint: string;
  initialValue: boolean;
}

interface Props {
  description: React.ReactNode;
  reportType: string;
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  toggles?: ToggleDefinition[];
}

export function TournamentReportPeriodForm({ description, reportType, onCloseClick, onSubmit, toggles = [] }: Props) {
  const now = new Date();
  const initialValues = toggles.reduce<any>((values, toggle) => ({ ...values, [toggle.field]: toggle.initialValue }), {
    dateFrom: getStartDateForSchoolYear(now),
    dateTo: now
  });

  return (
    <Formik initialValues={initialValues} onSubmit={values => onSubmit(values, reportType)}>
      {({ values, setFieldValue }) => (
        <Form className="eReportForm unionTournamentReportForm">
          <div className="eReportForm__content">
            <ReportDescription>{description}</ReportDescription>
            <ReportSection
              number={1}
              title="Reporting period"
              hint="Choose the date range covered by the report."
              required
            >
              <ReportDateRange
                dateFrom={values.dateFrom}
                dateTo={values.dateTo}
                onChangeFrom={date => {
                  setFieldValue('dateFrom', date);
                  if (values.dateTo < date) setFieldValue('dateTo', date);
                }}
                onChangeTo={date => setFieldValue('dateTo', date)}
              />
            </ReportSection>
            {toggles.length > 0 ? (
              <ReportSection number={2} title="Report content" hint="Choose which schools should appear in the report.">
                <ReportToggleList>
                  {toggles.map(toggle => (
                    <ReportToggle
                      key={toggle.field}
                      name={toggle.field}
                      label={toggle.label}
                      hint={toggle.hint}
                      value={Boolean(values[toggle.field])}
                      onChange={value => setFieldValue(toggle.field, value)}
                    />
                  ))}
                </ReportToggleList>
              </ReportSection>
            ) : null}
          </div>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
